import React from 'react';
import styled from 'styled-components';

export enum BadgeType {
  Error = 'ERROR',
  Warning = 'WARNING',
  Normal = 'NORMAL',
  Success = 'SUCCESS',
  Primary = 'PRIMARY',
}

interface Props {
  type?: BadgeType | 'ERROR' | 'WARNING' | 'NORMAL' | 'SUCCESS' | 'PRIMARY';
}

const Badge: React.FC<React.PropsWithChildren<Props>> = ({
  type = 'NORMAL',
  children,
  ...otherProps
}) => {
  switch (type) {
    case BadgeType.Primary:
      return <PrimaryBadge {...otherProps}>{children}</PrimaryBadge>;
    case BadgeType.Error:
      return <ErrorBadge {...otherProps}>{children}</ErrorBadge>;
    case BadgeType.Warning:
      return <WarningBadge {...otherProps}>{children}</WarningBadge>;
    case BadgeType.Success:
      return <SuccessBadge {...otherProps}>{children}</SuccessBadge>;
    default:
      return <NormalBadge {...otherProps}>{children}</NormalBadge>;
  }
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem 0.8rem;
  height: 2.6rem;
  border-radius: 1.3rem;
  font-weight: 500;
  font-size: 1.4rem;
  text-transform: uppercase;
  white-space: nowrap;
`;

const ErrorBadge = styled(Wrapper)`
  background-color: ${({ theme }) => theme.status.errorLight};
  color: ${({ theme }) => theme.status.error};
`;

const WarningBadge = styled(Wrapper)`
  background-color: ${({ theme }) => theme.status.warningLight};
  color: ${({ theme }) => theme.status.warning};
`;

const NormalBadge = styled(Wrapper)`
  background-color: #f0f1f3;
  color: ${({ theme }) => theme.gray[300]};
`;

const SuccessBadge = styled(Wrapper)`
  background-color: ${({ theme }) => theme.status.succesLight};
  color: ${({ theme }) => theme.status.succes};
`;

const PrimaryBadge = styled(Wrapper)`
  background-color: ${({ theme }) => theme.primary[500]};
  color: white;
`;

export default Badge;
